export default __webpack_public_path__ + "static/media/assets-fonts-3_00.df67ea66.jpg";